import { NavItem } from "../../../components/nav/item";
import { NavSubItem } from "../../../components/nav/sub-item";
import { ORGANIZATION } from "icons";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

export function OrgNavigations() {
  const user = useSelector(selectUser);

  return (
    <NavItem
      title="Organization"
      icon={ORGANIZATION}
      url="/organization"
      matchExact={true}
    >
      <NavSubItem title="Employees" url="/organization/employees" />
      {/* <NavSubItem
        title={
          <span className="flex items-center justify-between">
            My Profile
            {(!user.discord_user_id || !user.github_username) && (
              <span className="ml-2 w-2 h-2 rounded-full bg-red-500 animate-pulse" />
            )}
          </span>
        }
        url="/organization/my-profile"
      /> */}
      <NavSubItem
        title="Entities"
        url="/organization/entities"
        requiredPermissions={{
          type: "collection",
          collection: "legal_entities",
        }}
      />
      <NavSubItem title="Assets" url="/organization/folders" />
      {/* <NavSubItem title="Companies" url="/crm/companies" /> */}
    </NavItem>
  );
}
